import {ToMatchOptions} from 'Shared/utilities/MapDiscriminatedUnion';

export class UnvalidatedHeight {
  public readonly key = 'UnvalidatedHeight';
  public readonly feet = '';
  public readonly inches = '';
}

export class InvalidHeight {
  public static create() {}
  public readonly key = 'InvalidHeight';

  constructor(public readonly feet: number | '', public readonly inches: number | '') {}
}

export class ValidHeight {
  public static create(feet: number | '', inches: number | '') {
    if (
      ((typeof feet === 'number' && feet >= 0 && feet <= 8) || feet === '' || isNaN(feet)) &&
      ((typeof inches === 'number' && inches >= 0 && inches < 12) || inches === '' || isNaN(inches))
    ) {
      return new ValidHeight(feet === 0 ? '' : feet, inches);
    } else {
      return new InvalidHeight(feet, inches);
    }
  }

  public readonly key = 'ValidHeight';

  constructor(public readonly feet: number | '', public readonly inches: number | '') {}
}

export type Height = ValidHeight | InvalidHeight | UnvalidatedHeight;

export type HeightOptions<TReturn> = ToMatchOptions<Height, 'key', TReturn>;

export const matchHeight = <TReturn>(height: Height, options: HeightOptions<TReturn>): TReturn => {
  switch (height.key) {
    case 'InvalidHeight':
      return options.InvalidHeight(height);
    case 'ValidHeight':
      return options.ValidHeight(height);
    case 'UnvalidatedHeight':
      return options.UnvalidatedHeight(height);
  }
};

export const isValidHeight = (height: Height): height is ValidHeight => height.key === 'ValidHeight';
export const isEmptyHeight = (height: Height): height is UnvalidatedHeight => height.key === 'UnvalidatedHeight';
export const isValidHeightFeet = (height: Height) =>
  (height.feet <= 8 && height.feet >= 0) || height.feet === '' || isNaN(height.feet);
export const isValidHeightInches = (height: Height) =>
  (height.inches >= 0 && height.inches < 12) || height.inches === '' || isNaN(height.inches);
export const EmptyHeight = new ValidHeight('', '');
